import { Theme } from "@mui/material";

export default function CardContent(theme: Theme) {
    return {
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: 20,
                    '&:last-child': {
                        paddingBottom: 20
                    }
                }
            }
        }
    };
}
